export enum MemberStatus {
    Active = 'Active',
    PendingCancel = 'PendingCancel',
    Cancelled = 'Cancelled'
}
